import { render, staticRenderFns } from "./ModelConfigForm.vue?vue&type=template&id=852f0fc8&scoped=true"
import script from "./ModelConfigForm.vue?vue&type=script&lang=js"
export * from "./ModelConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ModelConfigForm.vue?vue&type=style&index=0&id=852f0fc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852f0fc8",
  null
  
)

export default component.exports